import React from 'react';
import classNames from 'classnames/bind';
import styles from './Blog.module.scss';
import { BlogTopic, BlogTopicData, BlogTopicsProps } from 'models/blog-types';
import Icon from 'components/helpers/Icon';
import { getTopicTooltip, removeTopicFromFilter } from './Functions';

const cx = classNames.bind(styles);

const BlogTopicsList: React.FC<BlogTopicsProps> = (props) => {
  const { className, blogTopics, blogTopicsData, allowRemove } = props;
  const blogTopicsValidData = blogTopicsData?.filter((t) => t.topic && t.topic !== '$name');

  return (
    <>
      {blogTopics && blogTopics.length > 0 && (
        <div className={cx(className, 'blog-post-topic-tags')}>
          {blogTopics?.map((topic: BlogTopic, index: number) => (
            <span
              key={index}
              style={topic.fields?.color.value ? { backgroundColor: topic.fields?.color.value?.toString() } : undefined}
              title={getTopicTooltip(topic)}
            >
              {topic.fields?.topic.value}
            </span>
          ))}
        </div>
      )}

      {blogTopicsValidData && blogTopicsValidData.length > 0 && (
        <div className={cx(className, 'blog-post-topic-tags')}>
          {blogTopicsValidData?.map((topic: BlogTopicData, index: number) => (
            <div
              key={index}
              style={topic.color ? { backgroundColor: topic.color } : undefined}
              title={getTopicTooltip(undefined, topic.tooltip, topic.topic)}
              className={cx('blog-post-topic-tag')}
            >
              {topic.topic}
              {allowRemove && (
                <a onClick={() => removeTopicFromFilter(topic.id)}>
                  <Icon variant="close" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlogTopicsList;
